import { cropRect } from "./artLabelPreviewMath";

const WIDTH = 160;
const HEIGHT = Math.round((WIDTH * 88) / 63);

/** Carta com o recorte da janela desenhado por cima (passo 1 — Fonte). */
const SourceCropPreview = ({ imageUrl, crop }) => {
    const box = cropRect(crop, { x: 0, y: 0, width: WIDTH, height: HEIGHT });
    return (
        <div data-testid="source-crop" className="relative shrink-0" style={{ width: WIDTH, height: HEIGHT }}>
            {imageUrl ? (
                <img alt="carta" src={imageUrl} style={{ width: WIDTH, height: HEIGHT, objectFit: "fill", display: "block" }} />
            ) : (
                <div className="w-full h-full border border-dashed border-gray-500 text-xs text-gray-500 flex items-center justify-center">sem imagem</div>
            )}
            <div
                data-testid="source-crop-box"
                style={{ position: "absolute", left: box.x, top: box.y, width: box.width, height: box.height, border: "2px solid #d59106", background: "rgba(213,145,6,0.15)", boxSizing: "border-box", pointerEvents: "none" }}
            />
        </div>
    );
};

export default SourceCropPreview;
